/**
 * Stripe Helper - Subscription Management
 */

/**
 * Get Stripe publishable key from environment
 */
export function getStripePublishableKey() {
  const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
  if (!key) {
    console.error('Stripe publishable key not found in environment variables');
  }
  return key;
}

/**
 * Get Stripe price ID from environment
 */
export function getStripePriceId() {
  const priceId = process.env.REACT_APP_STRIPE_PRICE_ID;
  if (!priceId) {
    console.error('Stripe price ID not found in environment variables');
  }
  return priceId;
}

/**
 * Subscription tier labels
 */
export const SUBSCRIPTION_TIERS = {
  trial: {
    label: 'Free Trial',
    description: '14-day free trial',
    price: 0,
    features: ['All Premium Features', 'Cancel Anytime']
  },
  premium: {
    label: 'Premium',
    description: '$9.99/month',
    price: 9.99,
    features: [
      'Unlimited Family Members',
      'Unlimited Tasks & Chores',
      'AI-Powered Suggestions',
      'Photo Verification',
      'Recurring Tasks',
      'Allowance Tracking',
      'Shopping List Integration',
      'Priority Support'
    ]
  },
  free: {
    label: 'Free',
    description: 'Basic features',
    price: 0,
    features: ['Up to 3 members', 'Up to 10 tasks/month', 'Basic features']
  }
};

/**
 * Check if subscription is active
 */
export function isSubscriptionActive(familyData) {
  if (!familyData) return false;
  
  const status = familyData.subscriptionStatus;
  return status === 'trialing' || status === 'active';
}

/**
 * Check if trial has ended
 */
export function hasTrialEnded(familyData) {
  if (!familyData?.trialEndsAt) return false;
  
  const trialEnd = new Date(familyData.trialEndsAt);
  const now = new Date();
  return now > trialEnd;
}

/**
 * Get days remaining in trial
 */
export function getDaysRemainingInTrial(familyData) {
  if (!familyData?.trialEndsAt) return 0;
  
  const trialEnd = new Date(familyData.trialEndsAt);
  const now = new Date();
  const diffTime = trialEnd - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return Math.max(0, diffDays);
}

/**
 * Check if user needs to upgrade
 */
export function needsUpgrade(familyData) {
  if (!familyData) return false;
  
  // If trial ended and not subscribed
  if (hasTrialEnded(familyData) && familyData.subscriptionStatus !== 'active') {
    return true;
  }
  
  // If subscription canceled or past due
  if (familyData.subscriptionStatus === 'canceled' || 
      familyData.subscriptionStatus === 'past_due') {
    return true;
  }
  
  return false;
}













